module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"available_periods":"Текущий период","date":"Дата","time":"Время"},"kz":{}}')
  delete Component.options._Ctor
}
